// extracted by mini-css-extract-plugin
export default {"minimum_filter_not_reached":"list_minimum_filter_not_reached__xO95s"};